
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 21 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.211 7.624l5.126-4.454v8.856l-5.126-4.402zm-6.605.754l1.8 1.562c.283.24.651.386 1.054.386h.024c.404 0 .772-.146 1.058-.388l-.002.002 1.8-1.563 5.471 4.7H2.137l5.47-4.699zM2.13 2.115H18.82l-8.017 6.963a.51.51 0 01-.317.11h-.022a.509.509 0 01-.318-.11L2.13 2.115zM1.612 3.17l5.125 4.453-5.125 4.4V3.17zm18-2.035c-.2-.1-.435-.158-.684-.158H2.024c-.242 0-.48.056-.696.164l.01-.004a1.547 1.547 0 00-.863 1.386v10.143a1.55 1.55 0 001.548 1.549h16.902a1.55 1.55 0 001.549-1.549V2.523c0-.606-.35-1.13-.858-1.383l-.009-.005h.005z","fill":"#80A0AF"}})])
          )
        }
      }
    